import { KeyboardEvent, useState } from "react"

import { Avatar } from "@atoms/index"

import FileCarousel from "@organisms/SidePanel/SidePanelFilePreview/FileCarousel/FileCarousel"

import styles from "./ItemGallery.module.scss"
import { ItemGalleryProps } from "./ItemGallery.types"

export default function ItemGallery(props: ItemGalleryProps) {
    const { item } = props

    const [selectedIndex, setSelectedIndex] = useState(0)
    const selectedAttachment = item.attachments[selectedIndex] ?? item.attachments[0]

    // Move through the thumbnails with the arrow keys
    const handleKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
        if (event.key === "ArrowLeft") {
            event.preventDefault()
            setSelectedIndex((previousIndex) => Math.max(previousIndex - 1, 0))
        } else if (event.key === "ArrowRight") {
            event.preventDefault()
            setSelectedIndex((previousIndex) => Math.min(previousIndex + 1, item.attachments.length - 1))
        }
    }

    if (item.attachments.length === 0) {
        return (
            <div className={styles.galleryPlaceholder}>
                <Avatar variant="company" size="xl" fallbackName={item.name} />
            </div>
        )
    } else {
        return (
            <div className={styles.gallery} onKeyDown={handleKeyDown}>
                <div className={styles.galleryMain} tabIndex={0} role="group" aria-label="Item images">
                    <img src={selectedAttachment.signed_url} alt={selectedAttachment.upload_filename} loading="lazy" />
                </div>
                {item.attachments.length > 1 && (
                    <FileCarousel
                        files={item.attachments.map(
                            (attachment) =>
                                ({
                                    id: String(attachment.id),
                                    upload_filename: attachment.upload_filename,
                                    upload_mimetype: attachment.upload_mimetype,
                                    signed_url: attachment.signed_url,
                                    thumbnail_url: attachment.signed_url,
                                }) as Attachment,
                        )}
                        currentIndex={selectedIndex}
                        onSelect={setSelectedIndex}
                        isTabbable={false}
                    />
                )}
            </div>
        )
    }
}
